

import state from './UserState.js'
import mutations from './UserMutations.js'
import actions from './UserActions.js'
import getters from './UserGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
